import React, { useState } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import Backdrop from "@mui/material/Backdrop";
import Loading from "../../../Hook/Spinner";
import { Copy, CheckCheck } from 'lucide-react';

const GridList = ({ recordList, positive }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [copiedKey, setCopiedKey] = useState(null);


  // Handle opening modal for a specific product
  const handleViewClick = (product, keyName, idx) => {
    setModalData([{ ...product, _index: idx + 1 }]);
    setModalTitle(keyName);
    setShowModal(true);
  };

  const handleCopy = (text, key) => {
    if (!text) return;

    navigator.clipboard.writeText(text).then(() => {
      setCopiedKey(key);

      setTimeout(() => {
        setCopiedKey(null);
      }, 1500);
    });
  };

  // Format date and time
  const modifydate = (date) => {
    let dateWithouttime = new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    let dateWithtime = new Date(date).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    return `${dateWithouttime} ${dateWithtime}`;
  };

  // Render values in the grid
  const renderValue = (key, value) => {
    if (key === "product_data" && Array.isArray(value) && value.length > 0) {
      return value.map((product, idx) => (
        <Button
          key={idx}
          variant="primary"
          size="sm"
          onClick={() => handleViewClick(product, key, idx)}
          style={{ marginRight: "5px", marginBottom: "5px" }}
        >
          View {idx + 1}
        </Button>
      ));
    }

    if (key === "log_date" && value) {
      return modifydate(value);
    }

    return value !== null && value !== undefined ? value.toString() : "null";
  };

  // Split recordList into two columns
  const firstSection = recordList.slice(0, Math.ceil(recordList.length / 2));
  const secondSection = recordList.slice(Math.ceil(recordList.length / 2));

  return (
    <>
      {positive ? (
        <Backdrop open>
          <Loading />
        </Backdrop>
      ) : (
        <>
          <Container fluid className="grid-box">
            <Row>
              <Col xs={6} className="border border-0 border-end-1 border-muted p-1">
                {firstSection.map(([key, value], index) => {
                  const renderedValue = renderValue(key, value);

                  return (
                    <div
                      className="d-flex align-items-start gap-1 property-row"
                      key={index}
                    >
                      <label>{key}</label> -{" "}
                      <span className="d-flex align-items-center gap-1">

                        {/* SHOP NAME AS LINK */}
                        {key === "shop_name" ? (
                          <a
                            href={`https://${renderedValue}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {renderedValue}
                          </a>
                        ) : (
                          renderedValue
                        )}

                        {/* COPY BUTTON */}
                        {(key === "shop_email" || key === "customer_email") && (
                          <button
                            type="button"
                            className="btn btn-link p-0 d-flex align-items-center gap-1"
                            onClick={() => handleCopy(renderedValue, key)}
                            style={{ textDecoration: "none", color: "#28a745" }}
                          >
                            {copiedKey === key ? (
                              <>
                                <CheckCheck size={14} /> <small>Copied</small>
                              </>
                            ) : (
                              <>
                                <Copy size={14} /> <small>Copy</small>
                              </>
                            )}
                          </button>
                        )}

                      </span>
                    </div>
                  );
                })}
              </Col>


              <Col xs={6} className="border border-0 border-start-1 border-muted p-1">
                {secondSection.map(([key, value], index) => (
                  <div className="d-flex align-items-start gap-1 property-row" key={index}>
                    <label>{key}</label> - <span>{renderValue(key, value)}</span>
                  </div>
                ))}
              </Col>
            </Row>
          </Container>

          {/* Modal for individual product data */}
          <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {modalData.length > 0 ? (
                modalData.map((product) => (
                  <div key={product.id} style={{ marginBottom: "1rem" }}>
                    <h6>Product Data {product._index}</h6>
                    <div
                      style={{
                        background: "#f5f5f5",
                        padding: "10px",
                        borderRadius: "5px",
                        fontFamily: "monospace",
                      }}
                    >
                      {Object.entries(product).map(([key, value], i) => {
                        if (key === "_index") return null; // skip internal index
                        let displayValue = value;
                        // Try parsing nested JSON strings
                        try {
                          const parsed = JSON.parse(value);
                          displayValue = parsed;
                        } catch {}
                        return (
                          <div key={i} style={{ marginBottom: "4px" }}>
                            <span style={{ color: "#f0aa33", fontWeight: "bold" }}>
                              {key}
                            </span>
                            :{" "}
                            <span style={{ color: "#000" }}>
                              {typeof displayValue === "object"
                                ? JSON.stringify(displayValue, null, 2)
                                : displayValue?.toString() || ""}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))
              ) : (
                <p>No data</p>
              )}
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  );
};

export default GridList;
